import { defineComponent, reactive } from 'vue';
import moment from 'moment';
export default defineComponent({
  name: 'StateCard',
  props: {
    versions: String,
    types: String,
    updateTime: Date
  },
  setup(props, context) {
    console.log(props);
    console.log(context);
    const comData = reactive({
      ...props
    });
    const lastDays = moment(new Date(comData.updateTime)).add(30, 'days').endOf('days').fromNow().split(' ')[1];
    const lastFlag = lastDays <= 5 && comData.types == 1;
    // 1-草稿；2-上架审核中；3-在架中；4-下架审核中；5-已下架；6-已驳回；7-暂时下架中，8-上架审核中-新增软件
    const typemap = {
      1: '草稿保存中',
      2: '上架审核中',
      3: '在架中',
      4: '下架审核中',
      5: '已下架',
      6: '已驳回',
      7: '暂时下架中',
      8: '上架审核中'
    };
    const typeColor = {
      1: '#0029FF',
      2: '#0029FF',
      3: '#00BE63',
      4: '#F24014',
      5: '#000000',
      6: '#F24014',
      7: '#F24014',
      8: '#0029FF'
    };
    return {
      comData,
      typemap,
      typeColor,
      lastFlag,
      lastDays
    };
  }
});